export function AiButton({
  onClick,
  size = "sm",
  className = "",
  children,
  disabled = false
}) {
  return (
    <button
      type="button"
      className={`btn btn-ai btn-${size} d-inline-flex align-items-center gap-1 ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <i className="bi bi-stars"></i>
      {children}
    </button>
  );
}
